import { useCallback } from 'react'

export const useCta = () => {
    const generateCtaUrl = useCallback((ctaId = 'default', extraParams = {}) => {
        const baseUrl = '/signup'
        const params = new URLSearchParams({
            channel: 'googleadwords',
            ctaId: ctaId,
            ...extraParams
        })
        
        return `${baseUrl}?${params.toString()}`
    }, [])

    const handleCtaClick = useCallback((ctaId, linkParams = {}, _options) => {
        const url = generateCtaUrl(ctaId, linkParams)
        window.location.href = url
    }, [generateCtaUrl])

    return {
        generateCtaUrl,
        handleCtaClick
    }
}
